import { grid } from '../../script'

(function( $ ) {

	if ( ! document.querySelector('.carousel__items') ) {
		return
	}

	$( document ).ready(() => {

		let $carousels = $('.carousel__items');

		$carousels.each( ( e, carousel ) => {

			var $this = $( carousel );

			$this.slick({
				appendDots: $this.find('.carousel__item:last-child .carousel__dots'),
				dots: true,
				infinite: false,
				speed: 400,
				slidesToShow: 1,
				variableWidth: true,

				// Part of the hack in reversing the slider.
				nextArrow: '<button class="reset carousel__prev-arrow slick-next"><i class="icon-chev-left"></i><div class="sr-only">Previous Course</div></button>',
				prevArrow: '<button class="reset carousel__next-arrow slick-prev"><i class="icon-chev-right"></i><div class="sr-only">Next Course</div></button>',
			})

			$this.on( 'beforeChange', ( e, slick, currentSlide, nextSlide ) => {

				if ( ! window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {
					var $nextSlideText = $this.find( '.carousel__item[data-slick-index="' + nextSlide + '"] .text' ).clone()

					$this.find('.carousel__item:last-child .mobile-text').html( $nextSlideText.html() )
				}

				// Set dots position.
				var dotsCount = $this.find( '.slick-dots li' ).length
				var dotsWidth = dotsCount * 28 / 2

				var offsetStart = dotsWidth - 14
				var offset = offsetStart - ( nextSlide * 28 )

				$this.find( '.slick-dots' ).css( 'margin-left', offset + 'px' )
			})

			$this.on( 'init', ( e, slick ) => {
				var $carouselDots = $this.find('.slick-dots')
				var dotsWidth = $carouselDots.width()
				$carouselDots.css( 'margin-left', dotsWidth - 14 + 'px' )
			})

			$this.on( 'afterChange', ( e, slick, currentSlide ) => {
				var
					$next = $('.slick-next', $this),
					$prev = $('.slick-prev', $this);

				if (0 === currentSlide) {
					$next.prop('disabled', false)
					$prev.prop('disabled', true)
				} else if (slick.slideCount - 1 === currentSlide) {
					$next.prop('disabled', true)
					$prev.prop('disabled', false)
				} else {
					$next.prop('disabled', false)
					$prev.prop('disabled', false)
				}
			})

			// Disable drag & touch move.
			$this.slick( 'slickSetOption', 'touchMove', false )

		})

		let isMobile = ( ! window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches )

		setCarouselView( isMobile )
		setCarouselItemHeight()

		// On resize, check if it is the mobile/desktop display and reformat the carousels accordingly
		$( window ).on( 'resize', () => {

			if ( isMobile && window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {

				isMobile = false
				setCarouselView( false )

			} else if ( ! isMobile && ! window.matchMedia( '(min-width: ' + grid.mediumScreen + ')' ).matches ) {

				isMobile = true
				setCarouselView( true )

			}

		})

	})

	let setCarouselItemHeight = () => {

		var maxHeight = 0
		$('.carousel').each( (e, $elem) => {

			$( '.carousel__item', $elem ).each( ( e, $elemItem ) => {
				var elemHeight = $( $elemItem ).height();
				if ( elemHeight > maxHeight ) {
					maxHeight = elemHeight
				}
			} )


			$( '.carousel__item', $elem ).height( maxHeight )

		} )
	}

	var setCarouselView = ( isMobile ) => {

		if ( isMobile ) {

			$('.carousel__items').each( (e, elem) => {
				let $nextSlideText = $( '.slick-active .text', elem ).clone()
				$( '.carousel__item:last-child .mobile-text', elem )
					.html( $nextSlideText.html() )
					.click((event) => {
						$('#' + event.target.getAttribute('aria-controls'))
							.trigger('modal:open');
					})
			})

			$('.carousel__items').slick( 'slickGoTo', 0 )

		} else {

			$('.carousel__items').slick( 'slickGoTo', 999 )

		}

	}

	$('#wrapper')
		.addClass('black-alpha-50');

	$('.image-card-modal').each(function (index) {
		var
			$modal = $(this),
			$carousel = $modal.closest('.carousel__items.image_cards');

		$modal.modal()
			.on('click', '.next-modal-button, .prev-modal-button', function () {
				$modal.trigger('modal:swap');
			})
			.on('click', '.next-modal-button', function () {
				$carousel.slick('slickGoTo', index + 1);
			})
			.on('click', '.prev-modal-button', function () {
				$carousel.slick('slickGoTo', index - 1);
			});
	});

})( jQuery );



// WEBPACK FOOTER //
// ./assets/js/components/layout/carousel.js